
  export default {
    data() {
      return {
        drawer: true,
        drawerBtn: true,
        // liveCallers: '',
        phone_system: {
          // stream_type: null
        },
        liveCallerTimer: '',
        darkmode:true,
        is_loading_live_callers:true,
        tour: false,
      }
    },
    watch: {
      darkmode: function (val) {
        this.changeDarkMode();
      }
    },
    methods: {
      async useAdminLogin() {
        // Note this is actually backwards here, but it's the way it's been for a while
        return !this.$auth?.user?.phone_system?.use_users_login;
      },
      async logout() {
        return await this.$auth?.logout();
      },
      async verify_login() {
        return this.$auth?.loggedIn;
      },
      async loadLiveCallers() {
        // Skip the poll while the tab is backgrounded. An always-open dashboard
        // would otherwise hit /app/calls every 30s indefinitely (this poll was
        // by far the highest-volume GA event, ~1.5M). We refresh immediately on
        // visibilitychange when the user returns, so the count is never stale.
        if (process.client && document.hidden) {
          return;
        }
        this.is_loading_live_callers = true;
        // NOTE: intentionally no pls_app_track here — a GA event on every 30s
        // poll is pure noise (it's not a user action) and dominated event volume.
        try {
          var liveCallersApi = await this.$axios?.$get('/app/calls?live=1');
          this.$store?.commit("setAppLiveCallers",liveCallersApi.calls);
          this.$store?.commit("setAppLiveStreamType",liveCallersApi.phone_system.stream_type);
        } catch(e) {
          await this.$auth?.logout();
          this.$router?.push('/');
        }
        this.is_loading_live_callers = false;
      },
      onVisibilityChange() {
        // refresh right away when the user comes back to the tab
        if (process.client && !document.hidden) {
          this.loadLiveCallers();
        }
      },
      async changeDarkMode(track=true){
        if (this.darkmode){
          if (track){
            await this.pls_app_track('template_change_dark_mode_on');
          }
          this.$vuetify.theme.dark = true;
          this.$cookies?.set('darkmode', true);
        }else{
          if (track){
            await this.pls_app_track('template_change_dark_mode_off');
          }
          this.$vuetify.theme.dark = false;
          this.$cookies?.set('darkmode', false);
        }
      },
      // async startTour(){
      //   this.tour = true;
      // },
      hideMenu(){
        console.log(this.drawer);
        this.drawer = false;
        console.log(this.drawer);
        this.drawerBtn = false;
        this.tour = false;
      },
    },
    created(){
      this.verify_login();
      this.darkmode = this.$cookies?.get('darkmode');
      if (typeof this.darkmode === 'undefined'){
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          this.darkmode = true;
        }
      }
      this.changeDarkMode(false);
      this.loadLiveCallers();
      this.liveCallerTimer = setInterval(this.loadLiveCallers, 30000);
      if (process.client) {
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      }
      var pls_app_redirect_url = this.pls_app_redirect_url(this.$auth?.user?.phone_system);
      if (pls_app_redirect_url){
        this.$router?.push(pls_app_redirect_url);
      }
      this.$nuxt?.$on('hideMenu', this.hideMenu);
    },
    mounted(){
      this.$Delighted?.$updateUser(this.$auth?.user);
      // var page = this.pls_login_redirect_url(this.$auth?.user?.phone_system);
      // this.startTour();
    },
    beforeRouteLeave(to,from,next) {
      clearInterval(this.liveCallerTimer);
      next();
    },
    beforeDestroy () {
      clearInterval(this.liveCallerTimer);
      if (process.client) {
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }
    }
  }
